import { render } from "./S134387.vue?vue&type=template&id=d735db14"
const script = {}
script.render = render

export default script